declare namespace $ {

	type $shm_hitalama_map_page_arrow_widgets__from_widget_shm_hitalama_map_page_arrows_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_from_widget'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['from_widget'] >
	>
	type $shm_hitalama_map_page_arrow_widgets__to_widget_shm_hitalama_map_page_arrows_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_to_widget'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['to_widget'] >
	>
	type $shm_hitalama_map_page_arrow_widgets__kind_shm_hitalama_map_page_arrows_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_kind'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['kind'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_page_arrows_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['missing_relation_title'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_page_arrows_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_page_arrows_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['missing_relation_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__style_shm_hitalama_map_page_arrows_7 = $mol_type_enforce<
		({ 
			'position': string,
			'left': ReturnType< $shm_hitalama_map_page_arrows['missing_relation_left'] >,
			'top': ReturnType< $shm_hitalama_map_page_arrows['missing_relation_top'] >,
			'zIndex': number,
		})  & ReturnType< $mol_button_minor['style'] >
		,
		ReturnType< $mol_button_minor['style'] >
	>
	export class $shm_hitalama_map_page_arrows extends $mol_view {
		widget_arrow_kind( id: any): string
		missing_relation_title( id: any): string
		Missing_relation_icon( id: any): $mol_icon_plus
		missing_relation_create( id: any, next?: any ): any
		missing_relation_left( id: any): string
		missing_relation_top( id: any): string
		Map_page( ): $shm_hitalama_map_page
		visible( ): boolean
		widget_arrows( ): readonly($mol_view)[]
		widget_arrow_from_widget( id: any): $shm_hitalama_map_widget_float
		widget_arrow_to_widget( id: any): $shm_hitalama_map_widget_float
		Widget_arrow( id: any): $shm_hitalama_map_page_arrow_widgets
		Missing_relation( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=arrows.view.tree.d.ts.map